import { render, staticRenderFns } from "./GHA.vue?vue&type=template&id=6f0d9d2e&scoped=true&"
import script from "./GHA.vue?vue&type=script&lang=js&"
export * from "./GHA.vue?vue&type=script&lang=js&"
import style0 from "./GHA.vue?vue&type=style&index=0&id=6f0d9d2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0d9d2e",
  null
  
)

export default component.exports